<h2 mat-dialog-title class="flex items-center gap-3">
  @if (app().icon) {
    <img [src]="app().icon" [alt]="app().name" class="h-8 w-8 rounded" />
  } @else {
    <mat-icon>install_mobile</mat-icon>
  }
  <span>{{ 'Installa' | siaTranslate }} {{ app().name }}</span>
</h2>

<mat-dialog-content class="flex flex-col gap-4">
  @if (app().description) {
    <p class="text-sm opacity-80">{{ app().description }}</p>
  }

  @if (mode() === 'ios') {
    <p class="text-sm">
      {{ "Per installare l'app sul tuo dispositivo iOS segui questi passi:" | siaTranslate }}
    </p>
    <ol class="flex flex-col gap-3 pl-1">
      <li class="flex items-start gap-3">
        <mat-icon class="mt-0.5 shrink-0">ios_share</mat-icon>
        <span class="text-sm">
          {{ 'Tocca il pulsante Condividi nella barra di Safari.' | siaTranslate }}
        </span>
      </li>
      <li class="flex items-start gap-3">
        <mat-icon class="mt-0.5 shrink-0">add_box</mat-icon>
        <span class="text-sm">
          {{ "Scorri e tocca 'Aggiungi alla schermata Home'." | siaTranslate }}
        </span>
      </li>
      <li class="flex items-start gap-3">
        <mat-icon class="mt-0.5 shrink-0">check_circle</mat-icon>
        <span class="text-sm">
          {{ "Conferma il nome e tocca 'Aggiungi'." | siaTranslate }}
        </span>
      </li>
    </ol>
  } @else if (mode() === 'timeout') {
    <p class="text-sm">
      {{ 'Installazione non disponibile al momento. Riprova tra qualche secondo.' | siaTranslate }}
    </p>
  } @else {
    <p class="text-sm">
      {{
        "Il tuo browser non offre un'installazione automatica. Puoi comunque aggiungere l'app alla schermata Home dal menu del browser:"
          | siaTranslate
      }}
    </p>
    <ol class="flex flex-col gap-3 pl-1">
      <li class="flex items-start gap-3">
        <mat-icon class="mt-0.5 shrink-0">more_vert</mat-icon>
        <span class="text-sm">
          {{ 'Apri il menu del browser (di solito tre puntini in alto a destra).' | siaTranslate }}
        </span>
      </li>
      <li class="flex items-start gap-3">
        <mat-icon class="mt-0.5 shrink-0">add_to_home_screen</mat-icon>
        <span class="text-sm">
          {{ "Cerca la voce 'Installa app' o 'Aggiungi a schermata Home'." | siaTranslate }}
        </span>
      </li>
      <li class="flex items-start gap-3">
        <mat-icon class="mt-0.5 shrink-0">check_circle</mat-icon>
        <span class="text-sm">
          {{ 'Conferma e segui le istruzioni del browser.' | siaTranslate }}
        </span>
      </li>
    </ol>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">
    {{ 'Chiudi' | siaTranslate }}
  </button>
</mat-dialog-actions>
